import { useForm } from "react-hook-form";
import { Generico } from "../../components/Generico";
import { Criterio } from "../../models/riesgo/Criterio";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useEffect, useState } from "react";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { Paginator } from "primereact/paginator";

export const CriteriosGeneral = ({ permss, toast, generic, riesgo, tipo, listar, padreTipo, funcionalidades = [] }) => {
    const omodel = new Criterio();
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [load, setLoad] = useState(false);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { table, setLoading, totalRecords, setTotalRecords, lazyParams, onPage, inArea } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });
    const [registrosPadre, setRegistrosPadre] = useState([]);
    const [loadingPadres, setLoadingPadres] = useState(false);
    const [criterioPadre, setCriterioPadre] = useState(null);
    const necesitaPadreId = padreTipo ? true : false;

    useEffect(() => {
        loadLazyData();
    }, [lazyParams, tipo, criterioPadre]);

    const funcionalidadPorTipo = {
        MTR_RIESGO_ACTIVIDAD: 'MATRIZ-RIESGOS-CRUD-ACTIVIDAD',
        MTR_RIESGO_AREA: 'MATRIZ-RIESGOS-CRUD-AREA',
        MTR_RIESGO_MACRO_TIPO: 'MATRIZ-RIESGOS-CRUD-MACRO-TIPO',
        MTR_RIESGO_MACRO_CAT: 'MATRIZ-RIESGOS-CRUD-MACRO-CATEGORIA',
        MTR_RIESGO_PROCESO: 'MATRIZ-RIESGOS-CRUD-PROCESO',
        MTR_RIESGO_SUBPROCESO: 'MATRIZ-RIESGOS-CRUD-SUBPROCESO',
        MTR_RIESGO_FUENTE_RIESGO: 'MATRIZ-RIESGOS-CRUD-FUENTE-RIESGO',
        MTR_RIESGO_RIESGO: 'MATRIZ-RIESGOS-CRUD-RIESGO',
        MTR_RIESGO_CAUSA_RIESGO: 'MATRIZ-RIESGOS-CRUD-CAUSA-RIESGO',
        MTR_RIESGO_TRATAMIENTO: 'MATRIZ-RIESGOS-CRUD-TRATAMIENTO',
        MTR_RIESGO_CTRL_IMPLEMENTADO: 'MATRIZ-RIESGOS-CRUD-CTRL-IMPLEMENTADO',
        MTR_RIESGO_CONTROL_AYUDA: 'MATRIZ-RIESGOS-CRUD-CONTROL-AYUDA', // No editable de momento
        MTR_RIESGO_ACTOR_INTERNO: 'MATRIZ-RIESGOS-CRUD-ACTOR-INTERNO',
        MTR_RIESGO_ACTOR_EXTERNO: 'MATRIZ-RIESGOS-CRUD-ACTOR-EXTERNO',
        MTR_RIESGO_MONITOREO_REVISION: 'MATRIZ-RIESGOS-CRUD-MONITOREO-REVISION',
        MTR_RIESGO_MENSAJE: 'MATRIZ-RIESGOS-CRUD-MENSAJE',
        MTR_RIESGO_CANAL: 'MATRIZ-RIESGOS-CRUD-CANAL',
        MTR_RIESGO_CUANDO: 'MATRIZ-RIESGOS-CRUD-CUANDO',
    };

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.tipo = tipo;
        _lazyParams.listar = listar;
        _lazyParams.matrizId = riesgo?.id;
        if (criterioPadre?.id) { _lazyParams.padreId = criterioPadre.id; } else { delete _lazyParams.padreId; }
        if (necesitaPadreId && !criterioPadre?.id) {
            setLoadingPadres(true);
            _lazyParams.tipo = padreTipo;
            matrizSrv.listado('matriz-riesgo-criterio/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
                setTotalRecords(res.data.total);
                setRegistrosPadre(res.data?.registros);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => { setLoadingPadres(false); setLoading(false); });
            return;
        }
        matrizSrv.listado('matriz-riesgo-criterio/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
        }).finally(() => setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogCriterio(true);
    };

    const onSubmit = (data) => {
        data.tipo = tipo;
        data.listar = listar;
        data.matrizId = riesgo?.id;
        if (criterioPadre?.id) data.padreId = criterioPadre?.id;
        const esNuevo = getValues('id') == null;
        const endpoint = esNuevo ? 'matriz-riesgo-criterio/nuevo' : 'matriz-riesgo-criterio/editar';
        const servicio = esNuevo ? matrizSrv.nuevo : matrizSrv.editar;
        setLoad(true);
        servicio(data, endpoint).then(res => {
            generic.funcSuccess(res, toast);
            setDialogCriterio(false);
            loadLazyData();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setLoad(false));
    };

    const editar = () => {
        matrizSrv.consultar(`${item?.id}/${tipo}`, 'matriz-riesgo-criterio/consulta').then(res => {
            const registro = generic.renewValues(res.data, omodel.model);
            reset(registro);
            setDialogCriterio(true);
        });
    };

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo',
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    };

    const eliminar = () => {
        matrizSrv.eliminar(`${item?.id}/${tipo}?listar=${listar}&matrizId=${riesgo.id}`, 'matriz-riesgo-criterio/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    };

    const itemsMenu = () => {
        const items = [];
        const funcionalidadRequerida = funcionalidadPorTipo[tipo];
        const tiposNoEditables = tipo === 'MTR_RIESGO_CONTROL_AYUDA';
        if (permss?.actualizar && siOpcion(funcionalidadRequerida))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editar(), disabled: tiposNoEditables });
        if (permss?.eliminar && siOpcion(funcionalidadRequerida)) {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(), disabled: tiposNoEditables });
        }

        return [{ label: 'Opciones', items }];
    };

    const customDialogHeader = () => (
        <div>
            <i className="pi pi-user-edit icon-header" />
            <span className="title-header">
                {getValues('id') == null ? " Nuevo " : " Editar "}
            </span>
        </div>
    );

    const headerTemplate = (options) => {
        const funcionalidadRequerida = funcionalidadPorTipo[tipo];
        if (!siOpcion(funcionalidadRequerida) || tipo === 'MTR_RIESGO_CONTROL_AYUDA') return null;

        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" tooltip="Nuevo" onClick={openNew} />}
                </div>
            </div>
        );
    };

    // Si necesita padreId y no hay un padre seleccionado retornamos
    if (necesitaPadreId && !criterioPadre) {
        return (
            <Panel header="Opciones">
                {loadingPadres ? (
                    <div className="flex justify-content-center" style={{ padding: 16 }}>
                        <ProgressSpinner />
                    </div>
                ) : (
                    <>
                        <div style={{ marginBottom: '16px', fontSize: '1.1rem', fontWeight: 500 }}>
                            Seleccione una opción para continuar:
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridAutoRows: '60px', gap: '16px', }}>
                            {registrosPadre.length === 0 && (
                                <div style={{ gridColumn: '1/-1', textAlign: 'center', color: '#888' }}>
                                    No se encontraron registros.
                                </div>
                            )}
                            {registrosPadre.map((p) => (
                                <div key={p.id} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 8px rgba(0,0,0,0.1)'; }}
                                    style={{
                                        position: 'relative', padding: '12px', border: '1px solid #ddd', borderRadius: '10px', background: '#fff', boxShadow: '0 3px 8px rgba(0,0,0,0.1)',
                                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', transition: 'transform 0.2s, box-shadow 0.2s', cursor: 'pointer',
                                    }}>
                                    <Button label={p.nombre} onClick={() => setCriterioPadre(p)} className="p-button-raised" style={{ width: '100%', fontWeight: 'bold', backgroundColor: '#007ad9', borderColor: '#007ad9', color: '#fff', }} />
                                </div>
                            ))}
                        </div>
                    </>
                )}
                <Paginator first={lazyParams.first} rows={parseInt(process.env.REACT_APP_ROWS_NUM)} totalRecords={totalRecords} onPageChange={onPage} className="mb-4" />
            </Panel>
        );
    }

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                {necesitaPadreId && criterioPadre && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px', position: 'relative', }}>
                        <Button icon="pi pi-arrow-left" onClick={() => { setCriterioPadre(null); setLoadingPadres(true) }} style={{ position: 'absolute', left: 0, padding: '0.4rem 0.8rem', fontSize: '0.9rem', }} />
                        <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.2rem' }}>
                            {criterioPadre?.nombre}
                        </div>
                    </div>
                )}
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Panel>
            <Dialog visible={dialogCriterio} header={customDialogHeader} modal className="p-fluid dialog-personalizado"
                onHide={() => setDialogCriterio(false)} style={{ width: '400px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inArea('nombre', 5, 30, 12)}
                    </div>
                    {generic.buttonsForms(setDialogCriterio, load)}
                </form>
            </Dialog>
        </>
    );
};
